export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/sys/login'),
    meta: {
      hideTabBar: true,
      title: '登录',
      backPath: 'home'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/sys/register'),
    meta: {
      hideTabBar: true,
      title: '注册',
      backPath: 'home'
    }
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: () => import('@/views/sys/changePwd'),
    meta: {
      title: '修改密码',
      hideTabBar: true
    }
  }
]
